import { connect, ConnectedProps } from 'react-redux'
import CustomError from '../../../../../../../baseComponents/CustomError'
import { ModalLittle } from '../../../../../../../baseComponents/Modal'
import { LittleModalCreateEditChildrenFirst } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { checkIfCanCreateQuote } from '../../../../../../../utils/globals/order/order'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useCreateQuoteLogic from '../../../../../../../utils/hooks/quotes/useCreateQuoteLogic'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../utils/reducers/company/workingCenters'
import { CustomerPayload } from '../../../../../../../utils/reducers/customers/customer'
import { getSelectedWorkingCenter, getUserPermissions } from '../../../../../../../utils/reducers/getters'
import { QuoteOrderModelTypeExtended } from './types'
import locations from '../../../../../../../utils/globals/locations'
import SearchBarOrderCustomerDeciderComponent from '../../../../../../../specificComponents/sells/SearchBarOrderCustomerDecider'

interface ModalCreateQuoteOrderProps extends ModalEditComponentProps {}

const ModalCreateQuoteOrder: React.FC<ModalCreateQuoteOrderProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const userPermissionsCustomer = getUserPermissions('customer.profile.main')
    if (!permissionCheck(userPermissionsCustomer, 'read')) {
        return <ModalLittle opened={true} setOpened={setOpened}>
            <h2 className='mb-25'>
                <TwinTrans transKey='newQuote'>Nuevo presupuesto</TwinTrans>
            </h2>
            <CustomError textError={t('noPermissionsToSeeCustomers', 'No tienes permisos para ver los clientes')} />
        </ModalLittle>
    }
    return (
        <ModalCreateQuoteOrderConnect setOpened={setOpened} {...rest} />
    )
}

type ModalCreateQuoteOrderAfterPermissionsProps = ModalEditComponentProps & ReduxModalCreateQuoteOrderConnector & {}

const ModalCreateQuoteOrderAfterPermissions: React.FC<ModalCreateQuoteOrderAfterPermissionsProps> = ({ userPermissions, allRowData, workingCenters, customers,  ...rest }) => {
    const { t } = useTwinTranslation()
    const workingCenter = getSelectedWorkingCenter()
    const { customerInfo, createQuote, addressFields, myCustomerInfo, fileInfo } = useCreateQuoteLogic({ customers })
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<QuoteOrderModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                ...customerInfo,
                ...myCustomerInfo,
                {
                    name: 'custom_name',
                    label: t('customName', 'Nombre personalizado'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'OrderId',
                    component: 'Custom',
                    render: () => <SearchBarOrderCustomerDeciderComponent translations={{
                        title: t('quote', 'Presupuesto'),
                        seeText: t('showQuote', 'Ver presupuesto'),
                        duplicateText: t('duplicateQuoteDots', 'Duplicar presupuesto...')
                    }} baseURL={locations.quoteOrderSingle} getDataURL='/api/app/order/quote/getAllQuoteOrdersComplete' />
                },
                ...fileInfo,
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                }
            ],
        },
        ...addressFields,
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/quote/createQuoteOrder'} imagePath={['tmp']} translations={{
            title: t('newQuote', 'Nuevo presupuesto'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error} className='create_new_quote_modal' {...{ ...rest, onSubmit: createQuote }}>
            {error ? <CustomError textError={error} className='mb-10' /> : null}
            {!workingCenters?.[workingCenter?.id]?.dictCounters && !error ? <CustomError className='mb-10'  textError={t('notFoundWorkingCenterCounterAndForceCreate', 'No se han encontrado contadores disponibles. Si decide continuar, se generará uno automáticamente.')} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const modalCreateQuoteOrderDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
}
const mapModalCreateQuoteOrderConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, customers: state.customers })
const modalCreateQuoteOrderConnector = connect(mapModalCreateQuoteOrderConnector, modalCreateQuoteOrderDispatch)
type ReduxModalCreateQuoteOrderConnector = ConnectedProps<typeof modalCreateQuoteOrderConnector>

const modalCreateQuoteOrderConnectLoading = withLoading(ModalCreateQuoteOrderAfterPermissions, [{ fetchUrl: '/api/app/customer/getAllCustomers', propName: 'customers', setFunctionName: 'setCustomers' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModalCreateQuoteOrderConnect = modalCreateQuoteOrderConnector(modalCreateQuoteOrderConnectLoading)


export default ModalCreateQuoteOrder